import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Form, Modal, Input } from 'antd';
import { AccountInvoiceDetailsModel } from './AccountInvoiceDetailsModel';

interface AccountInvoiceCompleteModalProps {
  model: AccountInvoiceDetailsModel;
}

export const AccountInvoiceCompleteModal: React.FC<AccountInvoiceCompleteModalProps> = observer(({ model }) => {
  const { completeVisible } = model;
  const [form] = Form.useForm();

  useEffect(() => {
    if (completeVisible) {
      form.setFieldsValue({
        notes: ''
      });
    }
  }, [form, completeVisible]);

  return (
    <Modal
      title="Complete Invoice"
      visible={completeVisible}
      onOk={() => form.submit()}
      okText="Complete"
      onCancel={model.handleCancelComplete}
      confirmLoading={model.completeLoading}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={model.handleOkComplete}
      >
        <Form.Item
          label="Notes"
          name="notes"
        >
          <Input.TextArea placeholder="Add a note (optional)" rows={4} autoSize={{ minRows: 3, maxRows: 10 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
});
